export default __webpack_public_path__ + "static/media/Black Shoulder Peafowl.7b860c75.jpg";